import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const siteMapSX = {
	sectionHeader: {
		fontWeight: OpenSansFontWeights.bold,
		fontSize: '18px',
		lineHeight: 1.2,
		textTransform: 'uppercase',
		color: 'grey.500',
		py: 1.5,
		px: 2,
		borderBottom: '1px solid',
		borderBottomColor: 'grey.50',
		mb: 0,
		fontFamily: 'HelveticaNeue_THD',
	} as SxProps<Theme>,

	departmentsGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(4, 1fr)',
		'@media (max-width: 799px)': {
			gridTemplateColumns: '1fr',
		},
	} as SxProps<Theme>,

	departmentColumn: {
		display: 'flex',
		flexDirection: 'column',
		borderRight: '1px solid',
		borderRightColor: 'grey.50',
		'&:last-child': {
			borderRight: 'none',
		},
	} as SxProps<Theme>,

	departmentGroup: {
		display: 'flex',
		flexDirection: 'column',
		p: 2,
		borderBottom: '1px solid',
		borderBottomColor: 'grey.50',
	} as SxProps<Theme>,

	departmentTitle: {
		fontWeight: OpenSansFontWeights.bold,
		fontSize: '15px',
		lineHeight: 1.2,
		color: 'secondary.main',
		mb: 1,
		display: 'block',
		'&:hover': {
			color: 'secondary.dark',
			textDecoration: 'underline',
		},
	} as SxProps<Theme>,

	subcategoryLink: {
		fontSize: '15px',
		fontWeight: OpenSansFontWeights.regular,
		lineHeight: 1.2,
		color: 'secondary.main',
		m: 1,
		display: 'block',
		whiteSpace: 'normal',
		overflow: 'visible',
		textOverflow: 'clip',
		'&:hover': {
			color: 'secondary.dark',
			textDecoration: 'underline',
		},
	} as SxProps<Theme>,

	stickyNavWrapper: {
		width: '100%',
		position: 'sticky',
		top: 0,
		zIndex: 100,
		backgroundColor: 'background.paper',
		boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
		borderRadius: 0,
	} as SxProps<Theme>,

	NavWrapper: {
		width: '100%',
	} as SxProps<Theme>,

	navigateLegend: {
		fontWeight: OpenSansFontWeights.semibold,
		py: 1,
		px: 2,
		textAlign: 'left',
	} as SxProps<Theme>,

	navigateLinkText: {
		fontSize: '14px',
		color: 'grey.500',
		'&:hover': {
			color: 'primary.main',
		},
	} as SxProps<Theme>,

	navigateCard: {
		width: '100%',
		height: '80px',
		borderRadius: '0px',
	} as SxProps<Theme>,

	navigateBorder: {
		borderBottom: '4px solid backgroundGray',
		minHeight: '90px',
	} as SxProps<Theme>,

	navigateLink: {
		display: 'flex',
		alignItems: 'center',
		padding: '10px',
		cursor: 'pointer',
		ml: '8px',
	} as SxProps<Theme>,

	chevronIcon: {
		width: '16px',
		height: '16px',
		ml: 0.5,
		color: 'primary.main',
	} as SxProps<Theme>,

	departmentsContainer: {
		bgcolor: 'background.paper',
		width: '100%',
		pb: 2.5,
		borderRadius: 0,
	} as SxProps<Theme>,

	textEllipsis: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		maxWidth: '30ch',
	} as SxProps<Theme>,

	otherSectionsContainer: {
		borderBottom: '2px solid',
		borderBottomColor: 'grey.100',
		width: '100%',
	} as SxProps<Theme>,

	otherSectionsTitle: {
		borderBottom: '2px solid',
		borderBottomColor: 'primary.main',
		mt: '10px',
		fontSize: '30px',
		fontWeight: '300',
		display: 'inline-block',
		pb: '5px',
	} as SxProps<Theme>,
};
